
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"circle",attrs:{"clip-rule":"evenodd","d":"M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11 11-4.925 11-11zM12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0z"}}),_c('path',{staticClass:"arrow",attrs:{"d":"M15.266 12.668a.776.776 0 000-1.1l-3.85-3.85a.778.778 0 10-1.1 1.1l3.3 3.3-3.3 3.3a.778.778 0 101.1 1.1l3.85-3.85z"}})])
          )
        }
      }
    